import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CmsService} from '@spartacus/core';
import {CmsComponentData} from '@spartacus/storefront';
import {combineLatest, Observable} from 'rxjs';
import {filter, switchMap, tap} from 'rxjs/operators';

import {AimoCMSBannerCarouselComponent, AimoCMSBannerComponent} from '../../../model/cms.model';
import {AimoGtmStoredParams} from "../../../model/cart.model";
import {GTMItemListId} from "../../../service/gtm/aimo-gtm.model";

@Component({
    selector: 'aimo-banner-carousel',
    templateUrl: './aimo-banner-carousel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoBannerCarouselComponent {
    componentData$: Observable<AimoCMSBannerCarouselComponent>;

    banners$: Observable<AimoCMSBannerComponent[]>;
    gtmParams: AimoGtmStoredParams;

    constructor(
        protected component: CmsComponentData<AimoCMSBannerCarouselComponent>,
        protected cmsService: CmsService
    ) {
        this.componentData$ = this.component.data$
            .pipe(
                filter(Boolean),
                tap(data => this.gtmParams = {
                    gtmItemListId: GTMItemListId.frontPageCampaign,
                    gtmPromotionId: data.uid,
                    gtmPromotionName: data.name
                } as AimoGtmStoredParams));

        this.banners$ = this.componentData$.pipe(
            filter((data) => data != null),
            switchMap((data) =>
                combineLatest(
                    data?.banners
                        ?.split(' ')
                        .sort(() => (data.randomSort === 'true' ? (Math.random() > 0.5 ? 1 : -1) : 0))
                        .map((component) => this.cmsService.getComponentData<AimoCMSBannerComponent>(component)),
                ),
            ),
        );
    }
}
